module.exports = __webpack_public_path__ + "static/media/alarm_black.693b34bd.svg";